module.exports = __webpack_public_path__ + "img/google-takeout.be06cbd8.png";